module.exports = __webpack_public_path__ + "img/deterministic_signals_choices.af79459b.jpg";